const vehicleTypeTranslate: Record<string, string> = {
  'TYPES.VEHICLE.AUTOMOBILE': 'Automóvil',
  'TYPES.VEHICLE.MOTORCYCLE': 'Motocicleta',
  'TYPES.VEHICLE.MACHINERY': 'Maquinaria',
  //"TYPES.VEHICLE.PICKUP": "Camioneta",
  'TYPES.VEHICLE.NAUTIC': 'Náutico',
  'TYPES.VEHICLE.TRUCK': 'Camión',
  'TYPES.VEHICLE.BUS': 'Bus',
  //"TYPES.VEHICLE.SUV": "SUV"
}
export const vehicleTypeTranslateEx = (t: string) => {
  if (!t || t.indexOf('.') < 0) return t

  return vehicleTypeTranslate[t]
}
export default vehicleTypeTranslate
